wbApp.controller('EmailTemplateSaveDialogCtrl', ['$scope', '$translate', '$filter', 'messageTemplateSvc',
    function ($scope, $translate, $filter, messageTemplateSvc) {

        $scope.isSaving = false;

        $scope.onSaveAsNew = function () {

            if ($scope.isSaving) {
                return;
            }

            $scope.isSaving = true;

            $scope.model.id = null;

            messageTemplateSvc.insert($scope.model).$promise.then(
                function (data) {
                    $scope.isSaving = false;

                    $scope.onSave(data);
                },
                function (error) {
                    $scope.isSaving = false;
                }
            );
        }

        $scope.onSaveExisting = function () {

            if ($scope.isSaving) {
                return;
            }

            $scope.isSaving = true;

            messageTemplateSvc.update($scope.model).$promise.then(
                function () {
                    $scope.isSaving = false;

                    $scope.onSave($scope.model);
                },
                function (error) {
                    $scope.isSaving = false;
                }
            );
        }
}]);
